import { WrapperAmplitudeCompanyTab } from "components/company/v3/WrapperCompany";
import BrazilianPageLayout from "components/company/v3/layouts/BrazilianPageLayout";
import BrazilianFinancialsBox from "components/company/v3/brazilian/boxes/BrazilianFinancialsBox";
import { CompanyFinancialsTabEnum } from "components/company/v3/menu/enums";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import { parseAsStringEnum, useQueryState } from "nuqs";
import NotFound from "pages/404";
import BrazilianIssuerSeo from "components/company/v3/seo/BrazilianIssuerSeo";
import { useIntl } from "react-intl";

interface BrazilianFinancialsPageProps {
  tickerSymbol: string | null;
}

const BrazilianFinancialsPage: NextPage<BrazilianFinancialsPageProps> = function BrazilianFinancialsPage({
  tickerSymbol,
}) {
  const intl = useIntl();
  const [tab, setTab] = useQueryState(
    "tab",
    parseAsStringEnum<CompanyFinancialsTabEnum>(Object.values(CompanyFinancialsTabEnum)).withDefault(
      CompanyFinancialsTabEnum.FINANCIALS,
    ),
  );

  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();

  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <BrazilianPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyTab category="Ações" tab={tab} tickerSymbol={normalizedTickerSymbol}>
        <>
          <BrazilianIssuerSeo
            tickerSymbol={normalizedTickerSymbol}
            title={intl.formatMessage({
              defaultMessage: "Balanços",
              id: "XY/aB+",
              description: "Título da página - SEO",
            })}
          />
          <BrazilianFinancialsBox tickerSymbol={normalizedTickerSymbol} tab={tab} onChangeTab={setTab} />
        </>
      </WrapperAmplitudeCompanyTab>
    </BrazilianPageLayout>
  );
};

BrazilianFinancialsPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default BrazilianFinancialsPage;
